import Typography from "@mui/material/Typography";
import FormField from "shared/form/FormField";
import BoxContent from "shared/ui/BoxContent";
import Loading from "shared/ui/Loading";

const TestType = ({type = "", loading, errors, subject, subjects, setSubjectHandler}: any) => {
    return (
        <>
            <Typography variant="h3" mb={3} mt={3}>
                {type === "numericLiteracy" ? "Alege tipul testului" : "Alege materia"}
            </Typography>
            <BoxContent>
                <>
                    {loading.loading && loading.name === "subjects" ? (
                        <Loading show={true}/>
                    ) : (
                        <FormField
                            name="subject"
                            type="controlled-select"
                            label={type === "numericLiteracy" ? "Alege tipul testului" : "Alege materia"}
                            value={subject}
                            onChange={setSubjectHandler}
                            options={subjects.map((item: { name: string; id: string }) => {
                                return {
                                    label: item.name,
                                    value: item.id,
                                };
                            })}
                            errorMessage={errors.subject?.message}
                        />
                    )}
                    {type === "numericLiteracy" && (
                        <>
                            <Typography variant="body1" mt={2}>
                                <b>Test rapid</b>: Testul va avea până la 15 itemi și nu va genera un raport de evaluare.
                            </Typography>
                            <Typography variant="body1">
                                <b>Test evaluare</b>: Testul va până la 75 itemi și va genera un raport complet de evaluare.
                            </Typography>
                            <Typography variant="body1">
                                <b>Test screener ICAN (I-IV)</b>: Testul va avea 26 itemi și va genera un raport complet de evaluare.
                            </Typography>
                        </>
                    )}
                </>
            </BoxContent>
        </>
    );
};

export default TestType;
